// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v7z5_GfipB {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.v7z5_GfipB h4 {
  line-height: 3em;
}
.v7z5_GfipB .xl6xJ33E09 {
  float: left;
  width: 100%;
}
.v7z5_GfipB .ZYzRptOiwB {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.v7z5_GfipB .ZYzRptOiwB:hover {
  cursor: pointer;
}
.v7z5_GfipB .ZYzRptOiwB:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.FuSF1wHJwn .fnVqNvUBi_:focus {
  outline: none;
}
.FuSF1wHJwn .fnVqNvUBi_.IUSCFLC7XI._los8e4pKG {
  background: #375A88;
}
.FuSF1wHJwn .fnVqNvUBi_.IUSCFLC7XI._los8e4pKG span {
  color: #fff;
}
.FuSF1wHJwn ._los8e4pKG {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.FuSF1wHJwn ._los8e4pKG:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.FuSF1wHJwn input {
  height: 38px;
  min-width: 220px;
}
.ZYzRptOiwB.pZtGskI6No {
  background: #410102;
}
.ZYzRptOiwB.vEq5zGjGBr {
  background: #911318;
}
.ZYzRptOiwB.Zy15aUzgXz {
  background: #D8293B;
}
.ZYzRptOiwB.LIo8SLM4pn {
  background: #F2373C;
}
.ZYzRptOiwB.JixA1CjFRw {
  background: #FC4448;
}
.ZYzRptOiwB.N200k2BOWK {
  background: #ED535E;
}
.ZYzRptOiwB.w4qteTjVuc {
  background: #E34926;
}
.ZYzRptOiwB.q4XWZAjnck {
  background: #FC562B;
}
.ZYzRptOiwB.t8cyWv0JK0 {
  background: #FC6722;
}
.ZYzRptOiwB.DJlED4cGz9 {
  background: #FD7F24;
}
.ZYzRptOiwB.DLvijfU_XZ {
  background: #FD8D26;
}
.ZYzRptOiwB.wLHiU8R3Ra {
  background: #EC9C3E;
}
.ZYzRptOiwB.Cf8xjLtis_ {
  background: #0e673a;
}
.ZYzRptOiwB.jjuDCZLZDI {
  background: #208740;
}
.ZYzRptOiwB.K_tzzFhVXg {
  background: #239718;
}
.ZYzRptOiwB.N7S3Pke8fb {
  background: #55A84D;
}
.ZYzRptOiwB.nsFxc0AuLD {
  background: #4BBE5A;
}
.ZYzRptOiwB.rsYZDTXdo5 {
  background: #0CCA6A;
}
.ZYzRptOiwB.ak1wds81MB {
  background: #0A3C64;
}
.ZYzRptOiwB.C0L7TwRPIw {
  background: #0d487a;
}
.ZYzRptOiwB.ycE62TRzmR {
  background: #10538d;
}
.ZYzRptOiwB.ZXkZbF2gry {
  background: #115A99;
}
.ZYzRptOiwB.ER623g5bzo {
  background: #3387E2;
}
.ZYzRptOiwB.wqEOL93GXj {
  background: #1BA9CF;
}
.ZYzRptOiwB.apXD3kyffo {
  background: #d27c02;
}
.ZYzRptOiwB.fYhaNHJmBc {
  background: #fb9402;
}
.ZYzRptOiwB.j_5Csg0rJN {
  background: #FD9B30;
}
.ZYzRptOiwB.L5JBNgRukI {
  background: #FDBE2D;
}
.ZYzRptOiwB.OO4RySh8wb {
  background: #FED831;
}
.ZYzRptOiwB.FRebyRRRdm {
  background: #FFFD38;
}
.ZYzRptOiwB.UW_izaoHYt {
  background: #2D215C;
}
.ZYzRptOiwB.SKEFiJNhMP {
  background: #483C83;
}
.ZYzRptOiwB.LcssOerVoz {
  background: #58518d;
}
.ZYzRptOiwB.nj24siu6Dd {
  background: #7068A9;
}
.ZYzRptOiwB.ZkDml7hoqE {
  background: #7f78b2;
}
.ZYzRptOiwB.KCz2pCK4Qn {
  background: #8f88bc;
}
.ZYzRptOiwB.rOYzlQxoM9 {
  background: #000;
}
.ZYzRptOiwB.CfISN_xKgD {
  background: #282626;
}
.ZYzRptOiwB.mmSQe61P4I {
  background: #242222;
}
.ZYzRptOiwB.CrllZgoXR7 {
  background: #353838;
}
.ZYzRptOiwB.f93ci5eXmR {
  background: #666;
}
.ZYzRptOiwB.dGq4SGsT20 {
  background: #999;
}
.Fu966Kv_E0 {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.Fu966Kv_E0 .gSkEFEVvdj {
  display: none;
}
.tIBALg6XYw {
  display: flex;
  flex-direction: column;
  margin: 22px 80px 42px;
}
.tIBALg6XYw .oESDzJYQjf {
  max-width: 440px;
}
.tIBALg6XYw .oESDzJYQjf .at9ivoGeso {
  font-size: 12px;
  text-transform: initial;
  margin-bottom: 0;
  letter-spacing: normal;
  line-height: 16px;
}
.tIBALg6XYw .oESDzJYQjf .X2jlBGi6Dv {
  color: #262729;
  font-size: 12px;
}
.tIBALg6XYw .oESDzJYQjf .X2jlBGi6Dv .ISpZSyEwOT {
  text-transform: uppercase;
  margin-left: 8px;
  line-height: 16px;
}
.tIBALg6XYw .nwwmlf6YW_ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}
.tIBALg6XYw .nwwmlf6YW_ .OT81Ko2kMn {
  width: 200px;
  height: 166px;
  margin-right: 20px;
  border-radius: 3px;
  border: 1px solid #e5e5e5;
}
.tIBALg6XYw .nwwmlf6YW_ .OT81Ko2kMn .gpCarOBV3d {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  padding: 24px 4px;
}
.tIBALg6XYw .nwwmlf6YW_ .OT81Ko2kMn .gpCarOBV3d .QiU9euvOqS {
  height: 64px;
}
.tIBALg6XYw .nwwmlf6YW_ .OT81Ko2kMn .gpCarOBV3d .xKb108dtze {
  font-size: 64px;
}
.tIBALg6XYw .nwwmlf6YW_ .OT81Ko2kMn .gpCarOBV3d .KB3Rq8NQ8m {
  font-size: 14px;
  text-align: center;
  margin: 10px 0;
  letter-spacing: normal;
  line-height: 19px;
}
.tIBALg6XYw .nwwmlf6YW_ .OT81Ko2kMn:hover,
.tIBALg6XYw .nwwmlf6YW_ .qL6SFrTz3L {
  color: #F5F6FA;
  background-color: #007391;
}
.tIBALg6XYw .nwwmlf6YW_ .OT81Ko2kMn:hover .KB3Rq8NQ8m,
.tIBALg6XYw .nwwmlf6YW_ .qL6SFrTz3L .KB3Rq8NQ8m {
  color: #F5F6FA;
}
.tIBALg6XYw .nwwmlf6YW_ .OT81Ko2kMn:last-child {
  margin-right: 0;
}
.tIBALg6XYw .nwwmlf6YW_ .FIvqdf62qg {
  background-color: #ebebeb;
  width: 200px;
  height: 166px;
  margin-right: 20px;
  border-radius: 3px;
  border: 1px solid #e5e5e5;
}
.tIBALg6XYw .nwwmlf6YW_ .FIvqdf62qg .gpCarOBV3d {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
}
.tIBALg6XYw .nwwmlf6YW_ .FIvqdf62qg .gpCarOBV3d .QiU9euvOqS {
  height: 64px;
}
.tIBALg6XYw .nwwmlf6YW_ .FIvqdf62qg .gpCarOBV3d .xKb108dtze {
  font-size: 64px;
}
.tIBALg6XYw .nwwmlf6YW_ .FIvqdf62qg .gpCarOBV3d .KB3Rq8NQ8m {
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
  letter-spacing: normal;
  line-height: 19px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `v7z5_GfipB`,
	"color-row": `xl6xJ33E09`,
	"color-tile": `ZYzRptOiwB`,
	"picker-component": `FuSF1wHJwn`,
	"picker-element": `fnVqNvUBi_`,
	"active": `IUSCFLC7XI`,
	"btn": `_los8e4pKG`,
	"red-1": `pZtGskI6No`,
	"red-2": `vEq5zGjGBr`,
	"red-3": `Zy15aUzgXz`,
	"red-4": `LIo8SLM4pn`,
	"red-5": `JixA1CjFRw`,
	"red-6": `N200k2BOWK`,
	"orange-1": `w4qteTjVuc`,
	"orange-2": `q4XWZAjnck`,
	"orange-3": `t8cyWv0JK0`,
	"orange-4": `DJlED4cGz9`,
	"orange-5": `DLvijfU_XZ`,
	"orange-6": `wLHiU8R3Ra`,
	"green-1": `Cf8xjLtis_`,
	"green-2": `jjuDCZLZDI`,
	"green-3": `K_tzzFhVXg`,
	"green-4": `N7S3Pke8fb`,
	"green-5": `nsFxc0AuLD`,
	"green-6": `rsYZDTXdo5`,
	"blue-1": `ak1wds81MB`,
	"blue-2": `C0L7TwRPIw`,
	"blue-3": `ycE62TRzmR`,
	"blue-4": `ZXkZbF2gry`,
	"blue-5": `ER623g5bzo`,
	"blue-6": `wqEOL93GXj`,
	"yellow-1": `apXD3kyffo`,
	"yellow-2": `fYhaNHJmBc`,
	"yellow-3": `j_5Csg0rJN`,
	"yellow-4": `L5JBNgRukI`,
	"yellow-5": `OO4RySh8wb`,
	"yellow-6": `FRebyRRRdm`,
	"purple-1": `UW_izaoHYt`,
	"purple-2": `SKEFiJNhMP`,
	"purple-3": `LcssOerVoz`,
	"purple-4": `nj24siu6Dd`,
	"purple-5": `ZkDml7hoqE`,
	"purple-6": `KCz2pCK4Qn`,
	"black-1": `rOYzlQxoM9`,
	"black-2": `CfISN_xKgD`,
	"black-3": `mmSQe61P4I`,
	"black-4": `CrllZgoXR7`,
	"black-5": `f93ci5eXmR`,
	"black-6": `dGq4SGsT20`,
	"picker-theme": `Fu966Kv_E0`,
	"arrow-regular": `gSkEFEVvdj`,
	"modal-option__root": `tIBALg6XYw`,
	"modal-option__title": `oESDzJYQjf`,
	"title-option__label": `at9ivoGeso`,
	"title-option__jobTitle": `X2jlBGi6Dv`,
	"job-title__content": `ISpZSyEwOT`,
	"modal-option__list": `nwwmlf6YW_`,
	"modal-option__item": `OT81Ko2kMn`,
	"option-item__content": `gpCarOBV3d`,
	"option-item__img": `QiU9euvOqS`,
	"option-item__icon": `xKb108dtze`,
	"option-item__label": `KB3Rq8NQ8m`,
	"modal-option__item--selected": `qL6SFrTz3L`,
	"modal-option__item--disable": `FIvqdf62qg`
};
export default ___CSS_LOADER_EXPORT___;
